define(['exports', 'react', 'lodash', 'classnames', '../../i18n', '../utils/enums', './ProgrammingSecProblemAnalysis', './MCQSecProblemAnalysis', './styles/CandidateReportsView.css'], function (exports, _react, _lodash, _classnames, _i18n, _enums, _ProgrammingSecProblemAnalysis, _MCQSecProblemAnalysis) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _i18n2 = _interopRequireDefault(_i18n);

	var _enums2 = _interopRequireDefault(_enums);

	var _ProgrammingSecProblemAnalysis2 = _interopRequireDefault(_ProgrammingSecProblemAnalysis);

	var _MCQSecProblemAnalysis2 = _interopRequireDefault(_MCQSecProblemAnalysis);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _toConsumableArray(arr) {
		if (Array.isArray(arr)) {
			for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
				arr2[i] = arr[i];
			}

			return arr2;
		} else {
			return Array.from(arr);
		}
	}

	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];

			for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}

		return target;
	};

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var ProblemAnalysisList = function (_Component) {
		_inherits(ProblemAnalysisList, _Component);

		function ProblemAnalysisList() {
			_classCallCheck(this, ProblemAnalysisList);

			return _possibleConstructorReturn(this, (ProblemAnalysisList.__proto__ || Object.getPrototypeOf(ProblemAnalysisList)).apply(this, arguments));
		}

		_createClass(ProblemAnalysisList, [{
			key: 'renderTitleBar',
			value: function renderTitleBar() {
				return _react2.default.createElement(
					'div',
					{
						className: 'nunito-font bold normal-letter-spacing',
						style: { color: '#4A4A4A', fontSize: '1rem' } },
					_i18n2.default.t('dk-ui-lib.reports.problems_analysis')
				);
			}
		}, {
			key: 'getSanatizedProplemAnalysis',
			value: function getSanatizedProplemAnalysis(problemAnalysis) {
				var _sanatizedProplemAnalysis = _extends({}, problemAnalysis);
				var maxScore = 0;
				var score = 0;
				var testCases = [];

				problemAnalysis.subQuestions.forEach(function (subQuestion) {
					maxScore += subQuestion.maxScore;
					score += subQuestion.score;
					testCases = [].concat(_toConsumableArray(testCases), _toConsumableArray(subQuestion.testCases));
				});

				_sanatizedProplemAnalysis.score = score;
				_sanatizedProplemAnalysis.maxScore = maxScore;
				_sanatizedProplemAnalysis.outputSimilarityPercentage = score / maxScore * 100;
				_sanatizedProplemAnalysis.testCases = testCases;

				return _sanatizedProplemAnalysis;
			}
		}, {
			key: 'renderProblemAnalysis',
			value: function renderProblemAnalysis(sectionType, problemAnalysis, index) {
				var _sectionType = sectionType && sectionType.toLowerCase();

				if (_sectionType === _enums2.default.reports_sections.QUIZ) {
					return _react2.default.createElement(_MCQSecProblemAnalysis2.default, { index: index, problemAnalysis: problemAnalysis });
				} else {
					var _problemAnalysis = sectionType === _enums2.default.reports_sections.SQL ? this.getSanatizedProplemAnalysis(problemAnalysis) : problemAnalysis;
					return _react2.default.createElement(_ProgrammingSecProblemAnalysis2.default, { index: index, problemAnalysis: _problemAnalysis });
				}
			}
		}, {
			key: 'renderAnalysis',
			value: function renderAnalysis() {
				var _this2 = this;

				var _props = this.props,
				    sectionType = _props.sectionType,
				    _props$problemsAnalys = _props.problemsAnalysis,
				    problemsAnalysis = _props$problemsAnalys === undefined ? [] : _props$problemsAnalys;


				var _problemsAnalysis = _lodash2.default.flatMap(problemsAnalysis);

				return _react2.default.createElement(
					'div',
					{ className: 'clearfix' },
					_problemsAnalysis.map(function (problemAnalysis, index) {
						return _this2.renderProblemAnalysis(sectionType, problemAnalysis, index);
					})
				);
			}
		}, {
			key: 'render',
			value: function render() {

				return _react2.default.createElement(
					'div',
					{ className: 'clearfix mt3' },
					this.renderTitleBar(),
					this.renderAnalysis()
				);
			}
		}]);

		return ProblemAnalysisList;
	}(_react.Component);

	exports.default = ProblemAnalysisList;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/ProblemAnalysisList.js
// module id = 464
// module chunks = 0